import { USER_CREATE_FAIL, USER_CREATE_REQUEST, USER_CREATE_SUCCESS, USER_DETAILS_CLEAR, USER_DETAILS_FAIL, USER_DETAILS_REQUEST, USER_DETAILS_SUCCESS, USER_LIST_FAIL, USER_LIST_REQUEST, USER_LIST_SUCCESS, USER_UPDATE_FAIL, USER_UPDATE_REQUEST, USER_UPDATE_SUCCESS } from "../constants/userConstants"
import { createUser, getUserById, getUsers } from "../services/userService";

export const listUsers = () => {
    return async (dispatch) => {
        try {
            dispatch({
                type: USER_LIST_REQUEST
            });

            const data = await getUsers();

            dispatch({
                type: USER_LIST_SUCCESS,
                payload: data.resultSet || []
            });
        } catch (error) {
            dispatch({
                type: USER_LIST_FAIL,
                payload: error.message
            });
        }
    }
}

export const getUserDetails = (serviceNumber) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: USER_DETAILS_REQUEST
            });

            const data = await getUserById(serviceNumber);

            dispatch({
                type: USER_DETAILS_SUCCESS,
                payload: data.resultSet?.[0]
            });
        } catch (error) {
            dispatch({
                type: USER_DETAILS_FAIL,
                payload: error.message
            })
        }
    }
}

export const createNewUser = (formData) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: USER_CREATE_REQUEST
            });

            await createUser(formData);

            dispatch({
                type: USER_CREATE_SUCCESS
            });
        } catch (error) {
            dispatch({
                type: USER_CREATE_FAIL,
                payload: error.message
            })
        }
    }
}

export const updateExistingUser = (formData) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: USER_UPDATE_REQUEST
            });

            // same as CREATE endpoint
            await createUser(formData);

            dispatch({
                type: USER_UPDATE_SUCCESS
            });
        } catch (error) {
            dispatch({
                type: USER_UPDATE_FAIL,
                payload: error.message
            })
        }
    }
}

export const clearUserDetails = () => ({
    type: USER_DETAILS_CLEAR
})